/* eslint-disable  */
import { Button } from "@material-ui/core";
import { Delete, Favorite } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { userDataActionCreators } from "../../../../../service/action-creators";
import { GetUserProfile } from "../../../../../service/action-creators/authAction";
import { GetNotifications } from "../../../../../service/action-creators/notificationAction";
import { ResetProductResponse } from "../../../../../service/action-creators/ProductAction";
import NotFoundComponent from "../../../../NotFoundComponent";
import RenderHome from "../../../home/RenderHome";
import Order_Chips from "./components/Order_Chips";

// Matches ApplyLoans/LoanDetailed, so the hire purchase and loan forms share
// one look. Full width by default, which is what makes the grid cells below
// collapse cleanly to a single column on a phone.
const inputCls =
  "mt-1 block w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent";
import "./MyCart.css";
import Resizer from "react-image-file-resizer";
import Webcam from "react-webcam";
import { FaCamera, FaImages, FaTimes, FaCheckCircle, FaPlus, FaPencilAlt, FaEye } from "react-icons/fa";
function MyCart() {
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    GetCartProducts,
    ResetUserDataResponse,
    RemoveProductFromCart,
    AddFavoriteProducts,
    UpdateCart,
    AddOrder,
    UpdateTemporaryOrder,
    GetTemporaryOrder,
    UpdateOrderTempPassportImageUpload,
    UpdateOrderTempIDCardImageUpload,
    GetMyOrders,
  } = bindActionCreators(userDataActionCreators, dispatch);

  const device = () => {
    return window.innerWidth < 1080;
  };
  const [isMobile, setIsMobile] = useState(device);
  const [orderItems, setOrderItems] = useState([
    { size: "", color: "", qty: "" },
  ]);
  const [changedPrice, setChangedPrice] = useState(null);
  const [changedOldPrice, setChangedOldPrice] = useState(null);
  const [termsChecked, setTermsChecked] = useState(false);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [formData, setFormData] = useState({});
  const [formState, setFormState] = useState(1);
  const [age, setAge] = useState(null);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [formError, setFormError] = useState({});

  const [seletedFiles, setSeletedFiles] = useState([]);
  const [previewFrontCard, setPreviewFrontCard] = useState(null);
  const [previewBackCard, setPreviewBackCard] = useState(null);
  const [previewPassportImage, setPreviewPassportImage] = useState(null);
  // const [privacyChecked, setPrivacyChecked] = useState(false);
  const [error, setError] = useState("");
  const [showCamera, setShowCamera] = useState(null); // "front" or "back"
  const [uploadingCard, setUploadingCard] = useState(null); // card currently uploading
  const webcamRef = React.useRef(null);
  const frontFileInputRef = React.useRef(null);
  const backFileInputRef = React.useRef(null);

  /* Preview reads what Confirm Order actually submits: handleConfirmSubmit
     sends {...formData}, so unsaved edits win over the saved temporary order. */
  const ov = (key) => formData?.[key] ?? temp_order?.[key];

  // Step 1 renders the date of birth as dd/mm/yyyy; the preview must match.
  const fmtDate = (raw) => {
    if (!raw) return "";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return raw;
    const day = String(d.getUTCDate()).padStart(2, "0");
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    return `${day}/${month}/${d.getUTCFullYear()}`;
  };

  /* Read-only preview pieces, mirroring ApplyLoans/Preview.js. onEdit jumps
     back to the step that owns the data rather than pushing a route. */
  const ReadField = ({ label, value }) => (
    <div>
      <label className="block text-sm font-medium text-gray-700">{label}</label>
      <input type="text" readOnly value={value || "N/A"}
        className="mt-1 block w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md shadow-sm text-sm cursor-not-allowed" />
    </div>
  );

  const SectionHeader = ({ title, step }) => (
    <div className="flex items-center justify-between gap-3 mb-4">
      <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
      <button
        type="button"
        title={`Edit ${title}`}
        onClick={(e) => {
          e.preventDefault();
          setFormState(step);
          window.scrollTo(0, 0);
        }}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-green-700 bg-green-50 border border-green-200 rounded-full hover:bg-green-100 hover:border-green-300 focus:outline-none transition-colors"
      >
        <FaPencilAlt size={11} />
        Edit
      </button>
    </div>
  );

  /* Same in-place upload loader used by the loan Uploads page. */
  const UploadOverlay = () => (
    <div className="upload-overlay">
      <div className="upload-spinner">
        <FaImages className="upload-spinner__icon" />
      </div>
      <span className="upload-overlay__label">Uploading…</span>
      <span className="upload-progress" />
    </div>
  );

  const CardStatus = ({ uploading, uploaded }) => {
    if (uploading) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "0.3rem", fontSize: "0.7rem", color: "#4f46e5", fontWeight: 500 }}>
          <span className="upload-pill-spinner" /> Uploading
        </span>
      );
    }
    if (uploaded) {
      return (
        <span style={{ display: "flex", alignItems: "center", gap: "0.25rem", fontSize: "0.7rem", color: "#16a34a", fontWeight: 500 }}>
          <FaCheckCircle /> Uploaded
        </span>
      );
    }
    return null;
  };

  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const capturePhoto = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc) {
      const file = dataURLtoFile(imageSrc, "camera-capture.png");
      if (showCamera === "front") {
        setPreviewFrontCard(imageSrc);
        setPreviewBackCard(imageSrc);
        try {
          Resizer.imageFileResizer(file, 400, 400, "png", 100, 0, (uri) => {
            setUploadingCard("front");
            UpdateOrderTempIDCardImageUpload(
              uri,
              temp_order?.frontIDImage_key ? temp_order?.frontIDImage_key : "",
              temp_order?._id
            );
          }, "file");
        } catch (err) { console.log(err); }
      } else {
        setPreviewPassportImage(imageSrc);
        try {
          Resizer.imageFileResizer(file, 400, 400, "png", 100, 0, (uri) => {
            setUploadingCard("back");
            UpdateOrderTempPassportImageUpload(
              uri,
              temp_order?.passportImage_key ? temp_order?.passportImage_key : "",
              temp_order?._id
            );
          }, "file");
        } catch (err) { console.log(err); }
      }
      setShowCamera(null);
    }
  };

  const handleGhanaCardUploadFront = (e) => {
    e.preventDefault();
    if (e?.target?.files[0]) {
      console.log("name", e?.target?.name);
      const file = e?.target?.files[0];
      const reader = new FileReader();
      reader.onload = (ev) => {
        setPreviewBackCard(ev?.target?.result);
        setPreviewFrontCard(ev?.target?.result);

        try {
          Resizer.imageFileResizer(
            file,
            400,
            400,
            "png",
            100,
            0,
            (uri) => {
              console.log(uri);
              setUploadingCard("front");
              UpdateOrderTempIDCardImageUpload(
                uri, // file,
                temp_order?.frontIDImage_key
                  ? temp_order?.frontIDImage_key
                  : "",
                temp_order?._id
              );
            },
            "file"
            // 200,
            // 200
          );
        } catch (err) {
          console.log(err);
        }
      };
      setSeletedFiles([...seletedFiles, file]);
      reader.readAsDataURL(file);

      // formDatas.append("file", e.target.files[0]);
    }
  };
  const handleGhanaCardBackUpload = (e) => {
    e.preventDefault();
    if (e?.target?.files[0]) {
      console.log("name", e?.target?.name);
      const file = e?.target?.files[0];
      const reader = new FileReader();
      reader.onload = (ev) => {
        setPreviewPassportImage(ev?.target?.result);
        console.log("file", file);
        try {
          Resizer.imageFileResizer(
            file,
            400,
            400,
            "png",
            100,
            0,
            (uri) => {
              setUploadingCard("back");
              UpdateOrderTempPassportImageUpload(
                uri,
                temp_order?.passportImage_key
                  ? temp_order?.passportImage_key
                  : "",
                temp_order?._id
              );
            },
            "file"
            // 200,
            // 200
          );
        } catch (err) {
          console.log(err);
        }
      };

      reader.readAsDataURL(file);

      // formDatas.append("file", e.target.files[0]);
    }
  };

  const product = useSelector((state) => state?.product);
  // const userData = useSelector((state) => state?.user);
  // const isLoading = product?.isLoading;

  // const {products, isLoading, paginate, response} = product

  const user = useSelector((state) => state?.user);

  const response = user?.response;
  const carts = user?.cart;
  const cartGrandTotal = user?.cartGrandTotal;
  // const quantity = user?.prodQuantity;
  const quantity = useSelector((state) => state?.quantityCounter);
  const auth = useSelector((state) => state?.auth);
  const userData = auth?.user;

  // Staff hire purchase collects no mandate number, OTP or affordability,
  // matching the staff loan form. The same flag gates the markup and the
  // validators below — hiding a field while still requiring it would block
  // the step with an error message pointing at nothing on screen.
  const isStaff = userData?.user_type === "STAFF";

  const temp_order = user?.temp_order;
  const myOrders = user?.orders;
  const BLOCKED_ORDER_STATUSES = ['submitted', 'initiated', 'approved'];
  const hasActiveOrder = myOrders?.some((o) => BLOCKED_ORDER_STATUSES.includes(o?.status));

  console.log("formData", formData);
  console.log("temp_order", temp_order);

  const validateForm1 = () => {
    let err = {};
    if (formData.name === "" || !formData.name) {
      err.name = "Please provide your name";
    }
    if (!dateOfBirth) {
      err.dateOfBirth = "Date of birth is required";
    }
    if (formData.ssnit === "" || !formData.ssnit) {
      err.ssnit = "SSNIT number is required";
    }
    if (formData.IDCardNumber === "" || !formData.IDCardNumber) {
      err.IDCardNumber = "ID Card Number is required";
    }
    if (
      formData.residential_address1 === "" ||
      !formData.residential_address1
    ) {
      err.residential_address1 = "Residential address is required";
    }
    // if (formData.work_address1 === "" || !formData.work_address1) {
    //   err.work_address1 = "Work address is required";
    // }
    if (formData.gender === "" || !formData.gender) {
      err.gender = "Gender is required";
    }

    setFormError({ ...err });
    console.log("object", Object.keys(err));
    return Object.keys(err).length < 1;
  };
  const validateForm2 = () => {
    let err = {};
    if (formData.personal_phone === "" || !formData.personal_phone) {
      err.personal_phone = "Phone number is required";
    }
    if (formData.work_phone === "" || !formData.work_phone) {
      err.work_phone = "Work phone number is required";
    }
    if (formData.email === "" || !formData.email) {
      err.email = "Email address is required";
    }

    if (!isStaff) {
      if (formData.mandate_number === "" || !formData.mandate_number) {
        err.mandate_number = "First mandate Number is required";
      }

      if (formData.otp_number === "" || !formData.otp_number) {
        err.otp_number = "First OTP number is required";
      }

      if (formData.mandate_number2 === "" || !formData.mandate_number2) {
        err.mandate_number2 = "Second mandate Number is required";
      }
      if (formData.otp_number2 === "" || !formData.otp_number2) {
        err.otp_number2 = "Second OTP number is required";
      }
    }

    setFormError({ ...err });
    console.log("object", Object.keys(err));
    return Object.keys(err).length < 1;
  };
  const validateFormEmployment = () => {
    let err = {};
    if (
      formData.employment_start_date === "" ||
      !formData.employment_start_date
    ) {
      err.employment_start_date = "Employment start date is required";
    }

    if (!isStaff && (formData.affordability === "" || !formData.affordability)) {
      err.affordability = "Affordability is required";
    }

    setFormError({ ...err });
    console.log("object", Object.keys(err));
    return Object.keys(err).length < 1;
  };
  // const validateForm4 = () => {
  //   let err = {};

  //   setFormError({ ...err });
  //   console.log("object", Object.keys(err));
  //   return Object.keys(err).length < 1;
  // };

  const validateFormGuarantor = () => {
    let err = {};

    if (!isStaff) {
      if (formData.mandate_number === "" || !formData.mandate_number) {
        err.mandate_number = "Mandate number is required";
      }
      if (formData.otp_number === "" || !formData.otp_number) {
        err.otp_number = "OTP Number is required";
      }
      if (formData.mandate_number2 === "" || !formData.mandate_number2) {
        err.mandate_number2 = "Second mandate number is required";
      }
      if (formData.otp_number2 === "" || !formData.otp_number2) {
        err.otp_number2 = "Second OTP Number is required";
      }
    }
    if (formData.guarantor_name === "" || !formData.guarantor_name) {
      err.guarantor_name = "Guarantor name is required";
    }
    if (formData.guarantor_staff_id === "" || !formData.guarantor_staff_id) {
      err.guarantor_staff_id = "Guarantor Staff ID is required";
    }
    if (formData.guarantor_phone === "" || !formData.guarantor_phone) {
      err.guarantor_phone = "Guarantor phone number is required";
    }
    if (
      formData.guarantor_ghana_card === "" ||
      !formData.guarantor_ghana_card
    ) {
      err.guarantor_ghana_card = "National ID number of guarantor is required";
    } else {
      if (formData.guarantor_ghana_card?.length < 15) {
        err.guarantor_ghana_card = "National ID number is invalid";
      }
    }

    if (formData.guarantor_gps === "" || !formData.guarantor_gps) {
      err.guarantor_gps = "Guarantor GPS address is required";
    }
    if (
      formData.guarantor_occupation === "" ||
      !formData.guarantor_occupation
    ) {
      err.guarantor_occupation = "Guarantor occupation is required";
    }
    if (!isStaff) {
      if (
        formData.guarantor_mandate_number === "" ||
        !formData.guarantor_mandate_number
      ) {
        err.guarantor_mandate_number = "Guarantor Mandate number is required";
      }
      if (
        formData.guarantor_otp_number === "" ||
        !formData.guarantor_otp_number
      ) {
        err.guarantor_otp_number = "Guarantor OTP number is required";
      }
    }
    if (
      formData.guarantor_relationship === "" ||
      !formData.guarantor_relationship
    ) {
      err.guarantor_relationship = "Guarantor relationship is required";
    }
    // GUARANTOR 2
    if (formData.guarantor_name2 === "" || !formData.guarantor_name2) {
      err.guarantor_name2 = "Guarantor name is required";
    }
    if (formData.guarantor_staff_id2 === "" || !formData.guarantor_staff_id2) {
      err.guarantor_staff_id2 = "Guarantor Staff ID is required";
    }
    if (formData.guarantor_phone2 === "" || !formData.guarantor_phone2) {
      err.guarantor_phone2 = "Guarantor phone number is required";
    }
    if (
      formData.guarantor_ghana_card2 === "" ||
      !formData.guarantor_ghana_card2
    ) {
      err.guarantor_ghana_card2 = "National ID number of guarantor is required";
    } else {
      if (formData.guarantor_ghana_card2?.length < 15) {
        err.guarantor_ghana_card2 = "National ID number is invalid";
      }
    }

    if (formData.guarantor_gps2 === "" || !formData.guarantor_gps2) {
      err.guarantor_gps2 = "Guarantor GPS address is required";
    }
    if (
      formData.guarantor_occupation2 === "" ||
      !formData.guarantor_occupation2
    ) {
      err.guarantor_occupation2 = "Guarantor occupation is required";
    }
    if (!isStaff) {
      if (
        formData.guarantor_mandate_number2 === "" ||
        !formData.guarantor_mandate_number2
      ) {
        err.guarantor_mandate_number2 = "Guarantor Mandate number is required";
      }
      if (
        formData.guarantor_otp_number2 === "" ||
        !formData.guarantor_otp_number2
      ) {
        err.guarantor_otp_number2 = "Guarantor OTP number is required";
      }
    }
    if (
      formData.guarantor_relationship2 === "" ||
      !formData.guarantor_relationship2
    ) {
      err.guarantor_relationship2 = "Guarantor relationship is required";
    }

    setFormError({ ...err });
    return Object.keys(err).length < 1;
  };

  // const handlePriceChange = (e) => {
  //   let value = null;
  //   if (e.target) {
  //     value = e.target.value;
  //   }
  //   let convertedDuration = 0;
  //   if (Number(e.target.value) === 24) {
  //     convertedDuration = 2;
  //   } else if (Number(e.target.value) === 36) {
  //     convertedDuration = 3;
  //   } else if (
  //     // Number(e.target.value) == 1 ||
  //     Number(e.target.value) == 3 ||
  //     Number(e.target.value) == 6 ||
  //     Number(e.target.value) == 12
  //   ) {
  //     convertedDuration = 1;
  //   }
  //   const percentChange = 0.1;
  //   const retailPrice = Number(product?.new_price);
  //   const interestAmount = Number(retailPrice) * percentChange;
  //   const princpalCharge = Number(retailPrice) + Number(interestAmount);

  //   setChangedPrice(Number(princpalCharge / e.target.value).toFixed(2));

  //   // OLD PRICE
  //   const retailOldPrice = Number(product?.old_price);
  //   const interestOldAmount = Number(retailOldPrice) * percentChange;
  //   const princpalOldCharge =
  //     Number(retailOldPrice) + Number(interestOldAmount);

  //   setChangedOldPrice(Number(princpalOldCharge / e.target.value).toFixed(2));

  //   //Update the cart
  //   // UpdateCart(
  //   //   cart?._id,
  //   //   cart?.product_id?._id,
  //   //   body
  //   // );
  // };

  console.log("userData", userData);

  const handleDoBChange = (e) => {
    const today = new Date();
    const year = today.getFullYear();
    const dob = e?.target?.value.split("-")[0];

    const newAge = parseInt(year) - parseInt(dob);
    setAge(newAge);
    setDateOfBirth(e?.target?.value);
    setFormData({ ...formData, dateOfBirth: e?.target?.value });
  };

  const handleConfirmSubmit = (e) => {
    e.preventDefault();
    console.log("carts", carts);
    let newPayload = [];
    for (let i = 0; i < carts?.length; i++) {
      const payload = {
        product_id: carts[i].product_id?._id,
        product_img: carts[i].product_id?.images,
        product_price: carts[i].product_id?.new_price,
        product_name: carts[i].product_id?.product_name,
        product_old: carts[i].product_id?.old_price,
        product_quantity: carts[i].product_id?.quantity,
        color: carts[i].color,
        size: carts[i].size,
        qty: carts[i].quantity,
        period: carts[i].period,
        period_price: carts[i].period_price,
        sub_total: carts[i].sub_total,
        user_id: carts[i].user_id,
      };
      newPayload.push(payload);
      console.log("newPayload", newPayload);
      // CreateOrder(payload)
    }
    const data = {
      ...formData,
      age: age,
      dateOfBirth: dateOfBirth,
      acceptTerms: termsChecked,
      form_completed: true,
      order: newPayload,
    };

    // let isValid = validateForm4();

    // if (temp_order.frontIDImage == "" || temp_order.passportImage == "") {
    //   setError("Please make sure to upload front  and back of your Ghana Card");
    //   setTimeout(() => {
    //     setError(null);
    //   }, 7000);
    //   return
    // }

    UpdateTemporaryOrder(data, temp_order?._id);
    console.log("formData", data);
    setShowOrderForm(false);
  };

  const handleFormChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });

    console.log("formData.loanAmount", formData.loanAmount);
  };

  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsMobile(device);
    });
    return 0;
  }, []);

  const gender = userData?.name?.split(" ")[0] === "Mr." ? "Male" : "Female";
  const employer_name = userData?.facility?.split(" ")?.[1]?.split(":")?.[0] ?? "";
  useEffect(() => {
    GetTemporaryOrder();
    GetCartProducts();
    GetMyOrders();
    dispatch(GetUserProfile());
    dispatch(GetNotifications());
    setFormData({
      ...formData,
      staff_id: userData?.staff_id ?? temp_order?.staff_id,
      facility: userData?.facility ?? temp_order?.facility,
      // gender: gender,
      // name: userData?.name,
      IdCardType: "Ghana National Identification",
      employer_name: employer_name ?? temp_order?.employer_name,
      IdCardType: "Ghana National Identification",
      // employer_name: employer_name,

      name: temp_order?.name,
      IDCardNumber: temp_order?.IDCardNumber,
      age: age ?? temp_order?.age,
      dateOfBirth: userData?.dob || (dateOfBirth ?? temp_order?.dateOfBirth),
      ssnit: temp_order?.ssnit,
      gender: temp_order?.gender,
      residential_address1: temp_order?.residential_address1,
      residential_address2: temp_order?.residential_address2,
      work_phone: temp_order?.work_phone,
      work_address1: temp_order?.work_address1,
      work_address2: temp_order?.work_address2,
      email: userData?.email || temp_order?.email,
      personal_phone: userData?.phone_number || temp_order?.personal_phone,

      guarantor_name: temp_order?.guarantor_name,
      guarantor_staff_id: temp_order?.guarantor_staff_id,
      guarantor_phone: temp_order?.guarantor_phone,
      guarantor_ghana_card: temp_order?.guarantor_ghana_card,
      guarantor_gps: temp_order?.guarantor_gps,
      guarantor_occupation: temp_order?.guarantor_occupation,
      guarantor_mandate_number: temp_order?.guarantor_mandate_number,
      guarantor_otp_number: temp_order?.guarantor_otp_number,
      guarantor_relationship: temp_order?.guarantor_relationship,

      guarantor_name2: temp_order?.guarantor_name2,
      guarantor_staff_id2: temp_order?.guarantor_staff_id2,
      guarantor_phone2: temp_order?.guarantor_phone2,
      guarantor_ghana_card2: temp_order?.guarantor_ghana_card2,
      guarantor_gps2: temp_order?.guarantor_gps2,
      guarantor_occupation2: temp_order?.guarantor_occupation2,
      guarantor_mandate_number2: temp_order?.guarantor_mandate_number2,
      guarantor_otp_number2: temp_order?.guarantor_otp_number2,
      guarantor_relationship2: temp_order?.guarantor_relationship2,

      employment_start_date: temp_order?.employment_start_date,
      mandate_number: temp_order?.mandate_number,
      otp_number: temp_order?.otp_number,
      mandate_number2: temp_order?.mandate_number2,
      otp_number2: temp_order?.otp_number2,
      affordability: temp_order?.affordability,
      // employer_location: temp_order?.employer_location,

      frontIDImage: temp_order?.frontIDImage,
      frontIDImage_key: temp_order?.frontIDImage_key,
      passportImage: temp_order?.passportImage,
      passportImage_key: temp_order?.passportImage_key,
    });
    setDateOfBirth(temp_order?.dateOfBirth || userData?.dob);
    // setAge(temp_order?.age);
  }, []);
  useEffect(() => {
    setFormData({
      ...formData,
      staff_id: userData?.staff_id ?? temp_order?.staff_id,
      facility: userData?.facility ?? temp_order?.facility,
      // employer_location: temp_order?.employer_location,

      // gender: gender,
      // name: userData?.name,
      IdCardType: "Ghana National Identification",
      employer_name: employer_name ?? temp_order?.employer_name,

      name: userData?.name ?? temp_order?.name,
      IDCardNumber: temp_order?.IDCardNumber,
      age: age ?? temp_order?.age,
      dateOfBirth: userData?.dob || (dateOfBirth ?? temp_order?.dateOfBirth),
      ssnit: temp_order?.ssnit,
      gender: gender ?? temp_order?.gender,
      work_phone: temp_order?.work_phone,
      residential_address1: temp_order?.residential_address1,
      residential_address2: temp_order?.residential_address2,
      work_address1: temp_order?.work_address1,
      work_address2: temp_order?.work_address2,
      email: userData?.email || temp_order?.email,
      personal_phone: userData?.phone_number || temp_order?.personal_phone,

      guarantor_name: temp_order?.guarantor_name,
      guarantor_staff_id: temp_order?.guarantor_staff_id,
      guarantor_phone: temp_order?.guarantor_phone,
      guarantor_ghana_card: temp_order?.guarantor_ghana_card,
      guarantor_gps: temp_order?.guarantor_gps,
      guarantor_occupation: temp_order?.guarantor_occupation,
      guarantor_mandate_number: temp_order?.guarantor_mandate_number,
      guarantor_otp_number: temp_order?.guarantor_otp_number,
      guarantor_relationship: temp_order?.guarantor_relationship,

      guarantor_name2: temp_order?.guarantor_name2,
      guarantor_staff_id2: temp_order?.guarantor_staff_id2,
      guarantor_phone2: temp_order?.guarantor_phone2,
      guarantor_ghana_card2: temp_order?.guarantor_ghana_card2,
      guarantor_gps2: temp_order?.guarantor_gps2,
      guarantor_occupation2: temp_order?.guarantor_occupation2,
      guarantor_mandate_number2: temp_order?.guarantor_mandate_number2,
      guarantor_otp_number2: temp_order?.guarantor_otp_number2,
      guarantor_relationship2: temp_order?.guarantor_relationship2,

      employment_start_date: temp_order?.employment_start_date,
      mandate_number: temp_order?.mandate_number,
      otp_number: temp_order?.otp_number,
      mandate_number2: temp_order?.mandate_number2,
      otp_number2: temp_order?.otp_number2,
      affordability: temp_order?.affordability,

      frontIDImage: temp_order?.frontIDImage,
      frontIDImage_key: temp_order?.frontIDImage_key,
      passportImage: temp_order?.passportImage,
      passportImage_key: temp_order?.passportImage_key,
    });
    setDateOfBirth(temp_order?.dateOfBirth || userData?.dob);
    // setAge(temp_order?.age);
  }, [userData, temp_order]);

  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const dob = userData?.dob?.split("-")[0];
    console.log("dob", dob);
    const newAge = parseInt(year) - parseInt(dob);
    // console.log('newAge', newAge)
    setAge(newAge);
    // setDateOfBirth(e?.target?.value);
  }, [userData?.dob]);
  console.log("newAge", age);

  useEffect(() => {
    // Any settled response ends the ID-card upload spinner.
    if (user?.response?.state || product?.response?.state) {
      setUploadingCard(null);
    }

    if (
      user.response?.state === "SUCCESS" ||
      product?.response?.state === "SUCCESS"
    ) {
      // toast.success(response?.message);
      GetCartProducts();
      GetTemporaryOrder();
      setTimeout(() => {
        ResetUserDataResponse();
        dispatch(ResetProductResponse());
      }, 1500);
    } else if (
      user?.response?.state === "UPLOAD_SUCCESS" ||
      product?.response?.state === "UPLOAD_SUCCESS"
    ) {
      GetTemporaryOrder();
    } else if (
      user?.response?.state === "ERROR" ||
      product?.response?.state === "ERROR"
    ) {
      // toast.error(response?.message);
      setTimeout(() => {
        ResetUserDataResponse();
        dispatch(ResetProductResponse());
      }, 1500);
    }
  }, [user?.response?.state || product?.response.state]);

  return (
    <div className="MyCart">
      <RenderHome
        hidePageLoader
      // title={"My Cart"}
      >
        {!showOrderForm &&
          (carts?.length > 0 ? (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="mb-8">
              <h1 className="text-3xl font-bold text-gray-900">Your Cart</h1>
              <p className="mt-2 text-sm text-gray-600">
                Review and manage your items
              </p>
            </div>

            <div className="bg-white shadow rounded-lg overflow-hidden">
              <div className="divide-y divide-gray-200">
                {carts?.map((cart, index) => (
                  <div key={index} className="p-6 flex flex-col md:flex-row">
                    <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-6">
                      <img
                        className="h-32 w-32 object-cover rounded-md"
                        src={cart?.product_id?.images[0]?.url}
                        alt="product-pic"
                      />
                    </div>

                    <div className="flex-1">
                      <div className="flex justify-between items-start">
                        <div>
                          <h2 className="text-lg font-medium text-gray-900">
                            {cart?.product_id?.product_name.length > 50
                              ? cart?.product_id?.product_name.slice(0, 50) +
                                "..."
                              : cart?.product_id?.product_name}
                          </h2>
                          <p className="mt-1 text-sm text-gray-500">
                            {cart?.product_id?.quantity > 0 ? (
                              <span className="text-green-600">In Stock</span>
                            ) : (
                              <span className="text-red-600">Out of Stock</span>
                            )}
                          </p>
                        </div>
                        <p className="text-lg font-semibold text-gray-900">
                          &#8373;{cart?.sub_total.toFixed(2)} p/m
                        </p>
                      </div>

                      <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4">
                        {cart?.product_id?.sizes.length > 0 && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Size
                            </label>
                            <select
                              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                              name="size"
                              onChange={(e) => {
                                let body = {
                                  size: e.target.value,
                                  period_price: cart?.period_price,
                                };
                                UpdateCart(
                                  cart?._id,
                                  cart?.product_id?._id,
                                  body
                                );
                              }}
                            >
                              <option value={cart?.size}>{cart?.size}</option>
                              {cart?.product_id?.sizes?.map((size, index) => (
                                <option key={index} value={size}>
                                  {size}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        {cart?.product_id?.colors.length > 0 && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                              Color
                            </label>
                            <select
                              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                              name="color"
                              onChange={(e) => {
                                let body = {
                                  color: e.target.value,
                                  period_price: cart?.period_price,
                                };
                                UpdateCart(
                                  cart?._id,
                                  cart?.product_id?._id,
                                  body
                                );
                              }}
                            >
                              <option value={cart?.color}>{cart?.color}</option>
                              {cart?.product_id?.colors?.map((color, index) => (
                                <option key={index} value={color}>
                                  {color}
                                </option>
                              ))}
                            </select>
                          </div>
                        )}

                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">
                            Quantity
                          </label>
                          <input
                            type="number"
                            min="1"
                            name="quantity"
                            defaultValue={cart?.quantity}
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                            onChange={(e) => {
                              let body = {
                                quantity: e.target.value,
                                period_price: cart?.period_price,
                              };
                              UpdateCart(
                                cart?._id,
                                cart?.product_id?._id,
                                body
                              );
                            }}
                          />
                        </div>
                      </div>

                      <div className="mt-4 flex justify-between items-center">
                        <div className="flex space-x-2">
                          <button
                            onClick={() =>
                              AddFavoriteProducts(cart?.product_id?._id)
                            }
                            className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          >
                            <Favorite className="h-5 w-5 mr-1" />
                            Save
                          </button>
                          <button
                            onClick={() =>
                              RemoveProductFromCart(cart?.product_id?._id)
                            }
                            className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                          >
                            <Delete className="h-5 w-5 mr-1" />
                            Remove
                          </button>
                        </div>
                        <div className="text-sm text-gray-500">
                          {cart?.period} months term
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="border-t border-gray-200 px-6 py-4">
                <div className="flex justify-between items-center">
                  <h3 className="text-lg font-medium text-gray-900">Total</h3>
                  <p className="text-xl font-semibold text-gray-900">
                    &#8373;{cartGrandTotal?.toFixed(2)}
                  </p>
                </div>
              </div>

              <div className="px-6 py-4 bg-gray-50 flex flex-wrap justify-end items-center gap-3">
                <Link
                  to={"/upnmg-shopping-mall"}
                  className="inline-flex items-center gap-2 mr-auto px-5 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <FaPlus size={12} /> Add more items
                </Link>
                {hasActiveOrder && (
                  <span style={{ fontSize: "0.8rem", color: "#b45309", background: "#fef3c7", padding: "0.4rem 0.9rem", borderRadius: "0.4rem", fontWeight: 500 }}>
                    You have an active hire purchase application
                  </span>
                )}
                <button
                  onClick={() => {
                    if (hasActiveOrder) return;
                    setShowOrderForm(true);
                    window.scrollTo(0, 0);
                  }}
                  disabled={hasActiveOrder}
                  style={hasActiveOrder ? { opacity: 0.4, cursor: "not-allowed" } : {}}
                  className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Confirm Order
                </button>
              </div>
            </div>
            </div>
          ) : (
            <div className="py-8">
              <NotFoundComponent title={"Your cart is empty"} />
              <div className="flex justify-center mt-4">
                <Link
                  to={"/upnmg-shopping-mall"}
                  className="inline-flex items-center gap-2 px-6 py-3 text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  <FaPlus size={12} /> Browse products
                </Link>
              </div>
            </div>
          ))}

        {showOrderForm && (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="mb-6 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
              <div>
                <h1 className="text-3xl font-bold text-gray-900">
                  Confirm Order
                </h1>
                <p className="mt-2 text-sm text-gray-600">
                  Complete your hire purchase application
                </p>
              </div>
              <button
                type="button"
                onClick={() => {
                  setShowOrderForm(false);
                  window.scrollTo(0, 0);
                }}
                className="self-start inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Back to cart
              </button>
            </div>
            <div className="bg-white shadow rounded-lg p-4 sm:p-6 space-y-6 text-black">
            {error && (
              <div className="messgeContainer flex items-center justify-center">
                <p
                  className="message px-2 py-2"
                  style={{
                    border: "2px dotted rgb(248 113 113)",
                    borderRadius: "10px",
                    color: "red",
                    fontSize: ".9rem",
                  }}
                >
                  {error}
                </p>
              </div>
            )}

            <Order_Chips formState={formState} />
            <div className="form">
              <form action="">
                {formState === 1 && (
                  <div className="form_area form1">
                    <h3 className="text-xl font-semibold mb-4 text-gray-800">Personal Information</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                      <div className="sm:col-span-2">
                        <label htmlFor="fullname" className="block text-sm font-medium text-gray-700">
                          Full Name<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="name"
                          placeholder="Your full name"
                          readOnly
                          defaultValue={userData?.name}
                          id="fullname"
                        />
                        <span className="block text-red-500 text-xs mt-1">{formError.name}</span>
                      </div>

                      {/* <div>
                        <label htmlFor="fullname" className="block text-sm font-medium text-gray-700">
                          Choose Your Region
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <select
                          name="sector"
                          className={inputCls}
                          onChange={handleFormChange}
                        >
                         
                          <option value={""}></option>
                          <option value={"Southern"}>Greater Accra</option>
                          <option value={"Southern"}>Eastern</option>
                          <option value={"Southern"}>Central</option>
                          <option value={"Southern"}>Bono</option>
                          <option value={"Southern"}>Bono East</option>
                          <option value={"Southern"}>Ashanti</option>
                          <option value={"Southern"}>Ahafo</option>

                          <option value={"Northern"}>Western</option>
                          <option value={"Northern"}>Western North</option>
                          <option value={"Northern"}>Volta</option>
                          <option value={"Northern"}>Upper West</option>
                          <option value={"Northern"}>Upper East</option>
                          <option value={"Northern"}>Savannah</option>
                          <option value={"Northern"}>Oti</option>
                          <option value={"Northern"}>Northern</option>
                          <option value={"Northern"}>North East</option>
                        </select>
                      </div> */}
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                      <div>
                        <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700">
                          Date of Birth
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="dateOfBirth"
                          placeholder="dd/mm/yyyy"
                          id="dateOfBirth"
                          value={fmtDate(dateOfBirth || formData.dateOfBirth || "")}
                          readOnly
                          style={{ backgroundColor: "#f3f4f6", cursor: "not-allowed", color: "#111827" }}
                        />
                        <span className="block text-red-500 text-xs mt-1">
                          {formError.dateOfBirth}
                        </span>
                      </div>
                      <div>
                        <label htmlFor="age" className="block text-sm font-medium text-gray-700">
                          Age
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="age"
                          defaultValue={
                            age || (temp_order?.age ?? temp_order?.age)
                          }
                          id="age"
                          required
                          // value={age}
                          readOnly
                          placeholder="Calculated from date of birth"
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">{formError.age}</span>
                      </div>
                      <div>
                        <label htmlFor="ssnit" className="block text-sm font-medium text-gray-700">
                          SSNIT<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="ssnit"
                          id="ssnit"
                          placeholder="Enter your SSNIT number"
                          defaultValue={
                            formData?.ssnit ||
                            (temp_order?.ssnit ?? temp_order?.ssnit)
                          }
                          required
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">{formError.ssnit}</span>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                      <div>
                        <label htmlFor="IdCardType" className="block text-sm font-medium text-gray-700">
                          ID Type<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <select
                          name="IdCardType"
                          id="IdCardType"
                          value={"Ghana National Identification"}
                          className={inputCls}
                          onChange={(e) => handleFormChange(e)}
                        >
                          <option value="Ghana National Identification">
                            Ghana National Identification{" "}
                          </option>
                        </select>
                      </div>
                      <div>
                        <label htmlFor="id_number" className="block text-sm font-medium text-gray-700">
                          ID Number<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="IDCardNumber"
                          placeholder="Enter your Ghana Card number"
                          defaultValue={
                            formData?.IDCardNumber ||
                            (temp_order?.IDCardNumber ??
                              temp_order?.IDCardNumber)
                          }
                          id="id_number"
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">
                          {formError.IDCardNumber}
                        </span>
                      </div>
                      <div>
                        <label htmlFor="gender" className="block text-sm font-medium text-gray-700">
                          Gender<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <select
                          name="gender"
                          id="gender"
                          // value={gender}
                          onChange={(e) => handleFormChange(e)}
                          className={inputCls}
                        >
                          <option value={gender}>
                            {gender ||
                              (temp_order?.gender ?? temp_order?.gender)}
                          </option>
                          <option value="Female">Female</option>
                          <option value="Female">Male</option>
                          <option value="Other">Other</option>
                        </select>
                        <span className="block text-red-500 text-xs mt-1">{formError.gender}</span>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Residential Address
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>

                        <input
                          className={inputCls}
                          type="text"
                          name="residential_address1"
                          placeholder="Address line 1"
                          id="residential_address1"
                          defaultValue={
                            formData?.residential_address1 ||
                            (temp_order?.residential_address1 ??
                              temp_order?.residential_address1)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <input
                          className={inputCls}
                          type="text"
                          name="residential_address2"
                          placeholder="Address line 2 (optional)"
                          id="residential_address2"
                          aria-required="true"
                          defaultValue={
                            formData?.residential_address2 ||
                            (temp_order?.residential_address2 ??
                              temp_order?.residential_address2)
                          }
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">
                          {formError.residential_address1}
                        </span>
                      </div>
                      <div>
                        <label htmlFor="work_address1" className="block text-sm font-medium text-gray-700">
                          Work Address
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="work_address1"
                          placeholder="Work address line 1"
                          id="work_address1"
                          defaultValue={
                            formData?.work_address1 ||
                            (temp_order?.work_address1 ??
                              temp_order?.work_address1)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <input
                          className={inputCls}
                          type="text"
                          name="work_address2"
                          placeholder="Address line 2 (optional)"
                          defaultValue={
                            formData?.work_address2 ||
                            (temp_order?.work_address2 ??
                              temp_order?.work_address2)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">
                          {formError.work_address1}
                        </span>
                      </div>
                    </div>

                    <div className="flex justify-between items-center gap-3 mt-2">
                      <div></div>
                      <button
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none cursor-pointer"
                        name=""
                        // type="submit"
                        onClick={(e) => {
                          e.preventDefault();
                          let isValid = validateForm1();
                          if (isValid) {
                            // setFormState(2);
                            const data = {
                              ...formData,
                              age: age,
                              // dateOfBirth: dateOfBirth,
                              staff_id: userData?.staff_id,
                            };
                            // AddOrder(data)
                            if (!temp_order) {
                              console.log("formData", formData);
                              AddOrder(data);
                              setFormState(2);
                            } else {
                              UpdateTemporaryOrder(data, temp_order?._id);
                              setFormState(2);
                              // alert('update')
                            }
                          }
                        }}
                      >
                        Save and continue
                      </button>
                    </div>
                  </div>
                )}

                {formState === 2 && (
                  <>
                    {/* THE CONTACT DETAILS SECTION */}
                    <h3 className="text-xl font-semibold mb-4 text-gray-800">Contact Details</h3>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Phone Number<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="personal_phone"
                          placeholder="Enter your phone number"
                          defaultValue={
                            formData?.personal_phone ??
                            temp_order?.personal_phone ??
                            temp_order?.personal_phone
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">
                          {formError.personal_phone}
                        </span>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Work Phone
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          defaultValue={
                            formData?.work_phone ??
                            temp_order?.work_phone ??
                            temp_order?.work_phone
                          }
                          name="work_phone"
                          placeholder="Enter your work phone number"
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">
                          {formError.work_phone}
                        </span>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-4 mb-4">
                      <div className="sm:col-span-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Email Address
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="email"
                          name="email"
                          defaultValue={
                            formData?.email ??
                            temp_order?.email ??
                            temp_order?.email
                          }
                          placeholder="example@gmail.com"
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">{formError.email}</span>
                      </div>
                    </div>
                    {!isStaff && (
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        {!isStaff && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700">
                              Mandate Number 1
                              <span className="text-red-500 ml-0.5">*</span>
                            </label>
                            <input
                              className={inputCls}
                              type="text"
                              name="mandate_number"
                              defaultValue={
                                formData?.mandate_number ??
                                temp_order?.mandate_number ??
                                temp_order?.mandate_number
                              }
                              placeholder="Enter mandate number"
                              required
                              aria-required="true"
                              onChange={(e) => handleFormChange(e)}
                            />
                            <span className="block text-red-500 text-xs mt-1">
                              {formError.mandate_number}
                            </span>
                          </div>
                        )}
                        {!isStaff && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700">
                              OTP Number 1<span className="text-red-500 ml-0.5">*</span>
                            </label>
                            <input
                              className={inputCls}
                              type="number"
                              name="otp_number"
                              defaultValue={
                                formData?.otp_number ??
                                temp_order?.otp_number ??
                                temp_order?.otp_number
                              }
                              placeholder="Enter OTP number"
                              required
                              aria-required="true"
                              onChange={(e) => handleFormChange(e)}
                            />
                            <span className="block text-red-500 text-xs mt-1">
                              {formError.otp_number}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                    {!isStaff && (
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        {!isStaff && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700">
                              Mandate Number 2
                              <span className="text-red-500 ml-0.5">*</span>
                            </label>
                            <input
                              className={inputCls}
                              type="text"
                              name="mandate_number2"
                              defaultValue={
                                formData?.mandate_number2 ??
                                temp_order?.mandate_number2 ??
                                temp_order?.mandate_number2
                              }
                              placeholder="Enter mandate number"
                              required
                              aria-required="true"
                              onChange={(e) => handleFormChange(e)}
                            />
                            <span className="block text-red-500 text-xs mt-1">
                              {formError.mandate_number2}
                            </span>
                          </div>
                        )}
                        {!isStaff && (
                          <div>
                            <label className="block text-sm font-medium text-gray-700">
                              OTP Number 2<span className="text-red-500 ml-0.5">*</span>
                            </label>
                            <input
                              className={inputCls}
                              type="number"
                              name="otp_number2"
                              defaultValue={
                                formData?.otp_number2 ??
                                temp_order?.otp_number2 ??
                                temp_order?.otp_number2
                              }
                              placeholder="Enter OTP number"
                              required
                              aria-required="true"
                              onChange={(e) => handleFormChange(e)}
                            />
                            <span className="block text-red-500 text-xs mt-1">
                              {formError.otp_number2}
                            </span>
                          </div>
                        )}
                      </div>
                    )}

                    <div className="flex justify-between items-center gap-3 mt-2">
                      <button
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none cursor-pointer"
                        name=""
                        onClick={() => setFormState(1)}
                      >
                        Back
                      </button>
                      <button
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none cursor-pointer"
                        name=""
                        onClick={(e) => {
                          e.preventDefault();
                          let isValid = validateForm2();
                          if (isValid) {
                            UpdateTemporaryOrder(formData, temp_order?._id);
                            setFormState(3);
                          }
                        }}
                      >
                        Save and continue
                      </button>
                    </div>
                  </>
                )}

                {formState === 3 && (
                  <div className="form_area form2">
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                      <h3 className="col-span-full text-xl font-semibold mb-4 text-gray-800">Guarantors 1</h3>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Name<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="guarantor_name"
                          placeholder="Guarantor's full name"
                          defaultValue={
                            formData?.guarantor_name ||
                            (temp_order?.guarantor_name ??
                              temp_order?.guarantor_name)
                          }
                          required
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_name}
                        </span>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Staff ID<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="guarantor_staff_id"
                          placeholder="Guarantor's staff ID"
                          defaultValue={
                            formData?.guarantor_staff_id ||
                            (temp_order?.guarantor_staff_id ??
                              temp_order?.guarantor_staff_id)
                          }
                          lettersonly=""
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_staff_id}
                        </span>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Phone Number<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          required
                          name="guarantor_phone"
                          placeholder="Guarantor's phone number"
                          defaultValue={
                            formData?.guarantor_phone ||
                            (temp_order?.guarantor_phone ??
                              temp_order?.guarantor_phone)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_phone}
                        </span>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Ghana Card Number
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="guarantor_ghana_card"
                          placeholder="Ghana Card number"
                          defaultValue={
                            formData?.guarantor_ghana_card ||
                            (temp_order?.guarantor_ghana_card ??
                              temp_order?.guarantor_ghana_card)
                          }
                          required
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_ghana_card}
                        </span>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          GPS Address<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="guarantor_gps"
                          placeholder="GPS address"
                          required
                          defaultValue={
                            formData?.guarantor_gps ||
                            (temp_order?.guarantor_gps ??
                              temp_order?.guarantor_gps)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_gps}
                        </span>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Occupation
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          required
                          name="guarantor_occupation"
                          placeholder="Occupation"
                          defaultValue={
                            formData?.guarantor_occupation ||
                            (temp_order?.guarantor_occupation ??
                              temp_order?.guarantor_occupation)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_occupation}
                        </span>
                      </div>
                    </div>
                    <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-3"} gap-4 mb-4`}>
                      {!isStaff && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Mandate Number
                            <span className="text-red-500 ml-0.5">*</span>
                          </label>
                          <input
                            className={inputCls}
                            type="text"
                            name="guarantor_mandate_number"
                            placeholder="Mandate number"
                            defaultValue={
                              formData?.guarantor_mandate_number ||
                              (temp_order?.guarantor_mandate_number ??
                                temp_order?.guarantor_mandate_number)
                            }
                            required
                            aria-required="true"
                            onChange={(e) => handleFormChange(e)}
                          />
                          <span className="error-message">
                            {formError.guarantor_mandate_number}
                          </span>
                        </div>
                      )}
                      {!isStaff && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            OTP Number<span className="text-red-500 ml-0.5">*</span>
                          </label>
                          <input
                            className={inputCls}
                            type="text"
                            required
                            name="guarantor_otp_number"
                            placeholder="OTP number"
                            defaultValue={
                              formData?.guarantor_otp_number ||
                              (temp_order?.guarantor_otp_number ??
                                temp_order?.guarantor_otp_number)
                            }
                            aria-required="true"
                            onChange={(e) => handleFormChange(e)}
                          />
                          <span className="error-message">
                            {formError.guarantor_otp_number}
                          </span>
                        </div>
                      )}
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Relationship
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          required
                          name="guarantor_relationship"
                          placeholder="Relationship to borrower"
                          defaultValue={
                            formData?.guarantor_relationship ||
                            (temp_order?.guarantor_relationship ??
                              temp_order?.guarantor_relationship)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_relationship}
                        </span>
                      </div>
                    </div>

                    <div>
                      <p className="py-2">
                        I{" "}
                        <span className="font-bold underline">{`${
                          formData?.guarantor_name ||
                          (temp_order?.guarantor_name ??
                            temp_order?.guarantor_name) ||
                          ""
                        }`}</span>{" "}
                        hereby declare that in the event the borrower fails to
                        make payments or honor the contractual agreement herein
                        signed, I guarantee to make full payment to UPNMG-FUND
                        in the same way as if I were the original entity of the
                        said agreement except the default is in respect of
                        death. (GUARANTOR MUST BE A MEMBER OF UPNMG
                        IN GOOD STANDING)
                      </p>
                    </div>

                    {/* SECOND GUARANTOR SECTION */}
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                      <h3 className="col-span-full text-xl font-semibold mb-4 text-gray-800">Guarantors 2</h3>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Name<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="guarantor_name2"
                          placeholder="Guarantor's full name"
                          defaultValue={
                            formData?.guarantor_name2 ||
                            (temp_order?.guarantor_name2 ??
                              temp_order?.guarantor_name2)
                          }
                          required
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_name2}
                        </span>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Staff ID<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="guarantor_staff_id2"
                          placeholder="Guarantor's staff ID"
                          defaultValue={
                            formData?.guarantor_staff_id2 ||
                            (temp_order?.guarantor_staff_id2 ??
                              temp_order?.guarantor_staff_id2)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_staff_id2}
                        </span>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Phone Number<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          required
                          name="guarantor_phone2"
                          placeholder="Guarantor's phone number"
                          defaultValue={
                            formData?.guarantor_phone2 ||
                            (temp_order?.guarantor_phone2 ??
                              temp_order?.guarantor_phone2)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_phone2}
                        </span>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Ghana Card Number
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="guarantor_ghana_card2"
                          placeholder="Ghana Card number"
                          defaultValue={
                            formData?.guarantor_ghana_card2 ||
                            (temp_order?.guarantor_ghana_card2 ??
                              temp_order?.guarantor_ghana_card2)
                          }
                          required
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_ghana_card2}
                        </span>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          GPS Address<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="guarantor_gps2"
                          placeholder="GPS address"
                          required
                          defaultValue={
                            formData?.guarantor_gps2 ||
                            (temp_order?.guarantor_gps2 ??
                              temp_order?.guarantor_gps2)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_gps2}
                        </span>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Occupation
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          required
                          name="guarantor_occupation2"
                          placeholder="Occupation"
                          defaultValue={
                            formData?.guarantor_occupation2 ||
                            (temp_order?.guarantor_occupation2 ??
                              temp_order?.guarantor_occupation2)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_occupation2}
                        </span>
                      </div>
                    </div>
                    <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-3"} gap-4 mb-4`}>
                      {!isStaff && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Mandate Number
                            <span className="text-red-500 ml-0.5">*</span>
                          </label>
                          <input
                            className={inputCls}
                            type="text"
                            name="guarantor_mandate_number2"
                            placeholder="Mandate number"
                            defaultValue={
                              formData?.guarantor_mandate_number2 ||
                              (temp_order?.guarantor_mandate_number2 ??
                                temp_order?.guarantor_mandate_number2)
                            }
                            required
                            aria-required="true"
                            onChange={(e) => handleFormChange(e)}
                          />
                          <span className="error-message">
                            {formError.guarantor_mandate_number2}
                          </span>
                        </div>
                      )}
                      {!isStaff && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            OTP Number<span className="text-red-500 ml-0.5">*</span>
                          </label>
                          <input
                            className={inputCls}
                            type="text"
                            required
                            name="guarantor_otp_number2"
                            placeholder="OTP number"
                            defaultValue={
                              formData?.guarantor_otp_number2 ||
                              (temp_order?.guarantor_otp_number2 ??
                                temp_order?.guarantor_otp_number2)
                            }
                            aria-required="true"
                            onChange={(e) => handleFormChange(e)}
                          />
                          <span className="error-message">
                            {formError.guarantor_otp_number2}
                          </span>
                        </div>
                      )}
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Relationship
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          required
                          name="guarantor_relationship2"
                          placeholder="Relationship to borrower"
                          defaultValue={
                            formData?.guarantor_relationship2 ||
                            (temp_order?.guarantor_relationship2 ??
                              temp_order?.guarantor_relationship2)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="error-message">
                          {formError.guarantor_relationship2}
                        </span>
                      </div>
                    </div>

                    <div>
                      <p className="py-2">
                        I{" "}
                        <span className="font-bold underline">{`${
                          formData?.guarantor_name2 ||
                          (temp_order?.guarantor_name2 ??
                            temp_order?.guarantor_name2) ||
                          ""
                        }`}</span>{" "}
                        hereby declare that in the event the borrower fails to
                        make payments or honor the contractual agreement herein
                        signed, I guarantee to make full payment to UPNMG-FUND
                        in the same way as if I were the original entity of the
                        said agreement except the default is in
                        respect of death.
                      </p>
                    </div>

                    <div className="flex justify-between items-center gap-3 mt-2">
                      <div
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none cursor-pointer"
                        onClick={() => setFormState(2)}
                      >
                        Back
                      </div>
                      <button
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none cursor-pointer"
                        type="submit"
                        onClick={(e) => {
                          e.preventDefault();
                          let isValid = validateFormGuarantor();
                          if (isValid) {
                            UpdateTemporaryOrder(formData, temp_order?._id);
                            setFormState(4);
                          }
                        }}
                      >
                        Save and continue
                      </button>
                    </div>
                  </div>
                )}
                {formState === 4 && (
                  <div>
                    {/* THE CONTACT DETAILS SECTION */}

                    <div>
                      <h3 className="text-xl font-semibold mb-4 text-gray-800">Employment Details</h3>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                        <div>
                          <div className="grid grid-cols-1 gap-4">
                            <div>
                              <label className="block text-sm font-medium text-gray-700">
                                Employer
                                <span className="text-red-500 ml-0.5">*</span>
                              </label>

                              <select
                                className={inputCls}
                                type="text"
                                name="employer_name"
                                aria-required="true"
                                onChange={(e) => handleFormChange(e)}
                              >
                                <option
                                  value={
                                    employer_name ||
                                    (temp_order?.employer_name ??
                                      temp_order?.employer_name)
                                  }
                                >
                                  {employer_name ||
                                    (temp_order?.employer_name ??
                                      temp_order?.employer_name)}
                                </option>
                                <option value={"MOH"}>MOH</option>
                                <option value={"GHS"}>GHS</option>
                                <option value={"CHAG"}>CHAG</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Facility<span className="text-red-500 ml-0.5">*</span>
                          </label>
                          <input
                            className={inputCls}
                            type="text"
                            name="facility"
                            placeholder="Your facility"
                            required
                            readOnly
                            value={
                              userData?.facility ||
                              (temp_order?.facility ?? temp_order?.facility)
                            }
                            aria-required="true"
                            onChange={(e) => handleFormChange(e)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-4 mb-4">
                      <div className="sm:col-span-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Staff ID<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="staff_id"
                          placeholder="Your staff ID"
                          readOnly
                          value={
                            userData?.staff_id ||
                            (temp_order?.staff_id ?? temp_order?.staff_id)
                          }
                          required
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Employment Start Date
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="date"
                          name="employment_start_date"
                          defaultValue={
                            formData?.employment_start_date ||
                            (temp_order?.employment_start_date ??
                              temp_order?.employment_start_date)
                          }
                          required
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">
                          {formError.employment_start_date}
                        </span>
                      </div>
                    </div>

                    {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Mandate Number<span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="mandate_number"
                          placeholder="Enter mandate number"
                          defaultValue={
                            formData?.mandate_number ||
                            (temp_order?.mandate_number ?? temp_order?.mandate_number)
                          }
                          required
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">{formError.mandate_number}</span>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          OTP.
                          <span className="text-red-500 ml-0.5">*</span>
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          required
                          name="otp_number"
                          placeholder="Enter OTP number"
                          defaultValue={
                            formData?.otp_number ||
                            (temp_order?.otp_number ??
                              temp_order?.otp_number)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                        <span className="block text-red-500 text-xs mt-1">
                          {formError.otp_number}
                        </span>
                      </div>
                      
                    </div> */}
                    <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-2"} gap-4 mb-4`}>
                      {!isStaff && (
                        <div>
                          <label className="block text-sm font-medium text-gray-700">
                            Affordablility
                            <span className="text-red-500 ml-0.5">*</span>
                          </label>
                          <input
                            className={inputCls}
                            type="text"
                            name="affordability"
                            placeholder="Enter remaining affordability"
                            required
                            defaultValue={
                              formData.affordability ||
                              (temp_order?.affordability ??
                                temp_order?.affordability)
                            }
                            //  value={user?.facility}
                            aria-required="true"
                            onChange={(e) => handleFormChange(e)}
                          />
                          <span className="block text-red-500 text-xs mt-1">
                            {formError.affordability}
                          </span>
                        </div>
                      )}
                      <div>
                        <label className="block text-sm font-medium text-gray-700">
                          Occupation
                        </label>
                        <input
                          className={inputCls}
                          type="text"
                          name="occupation"
                          placeholder="Occupation"
                          defaultValue={
                            formData?.occupation ||
                            (temp_order?.occupation ?? temp_order?.occupation)
                          }
                          aria-required="true"
                          onChange={(e) => handleFormChange(e)}
                        />
                      </div>
                    </div>
                    <div className="flex justify-between items-center gap-3 mt-2">
                      <div
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none cursor-pointer"
                        onClick={() => setFormState(3)}
                      >
                        Back
                      </div>
                      <button
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none cursor-pointer"
                        type="submit"
                        onClick={(e) => {
                          e.preventDefault();
                          let isValid = validateFormEmployment();
                          // alert(1)
                          if (isValid) {
                            UpdateTemporaryOrder(formData, temp_order?._id);
                            setFormState(5);
                          }
                        }}
                      >
                        save and continue
                      </button>
                    </div>
                  </div>
                )}

                {formState === 5 && (
                  <>
                    <div className="form_area form4 id-cards-upload">
                      <h3 className="text-xl font-semibold mb-4 text-gray-800" style={{ fontSize: "1.1rem", fontWeight: 700, color: "#1f2937", marginBottom: "0.25rem" }}>Upload ID Card</h3>
                      <div className="description" style={{ fontSize: "0.8rem", color: "#6b7280", marginBottom: "1.25rem" }}>
                        Only Ghana National Identification card is accepted. Other
                        ID cards will be rejected.
                      </div>

                      <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "1rem", marginBottom: "1.25rem" }}>
                        {/* Front Card */}
                        <div style={{ background: "#fff", borderRadius: "0.75rem", border: "1px solid #e5e7eb", padding: "1rem", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem" }}>
                            <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "#1f2937" }}>Ghana Card (Front)</span>
                            <CardStatus
                              uploading={uploadingCard === "front"}
                              uploaded={!!(previewFrontCard || temp_order?.frontIDImage)}
                            />
                          </div>
                          <div style={{ position: "relative", width: "100%", height: "160px", borderRadius: "0.5rem", border: "2px dashed #d1d5db", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", background: "#f9fafb", marginBottom: "0.75rem" }}>
                            {uploadingCard === "front" && <UploadOverlay />}
                            {(previewFrontCard || temp_order?.frontIDImage) ? (
                              <img src={previewFrontCard || temp_order?.frontIDImage} alt="Front ID" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            ) : (
                              <div style={{ textAlign: "center", color: "#9ca3af" }}>
                                <FaImages style={{ fontSize: "2rem", marginBottom: "0.3rem" }} />
                                <div style={{ fontSize: "0.75rem" }}>No image uploaded</div>
                              </div>
                            )}
                          </div>
                          <div style={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
                            <button type="button" onClick={() => frontFileInputRef.current.click()} disabled={uploadingCard === "front"} style={{ display: "flex", alignItems: "center", gap: "0.35rem", padding: "0.45rem 0.9rem", border: "1px solid #d1d5db", borderRadius: "0.5rem", background: "#fff", cursor: uploadingCard === "front" ? "not-allowed" : "pointer", opacity: uploadingCard === "front" ? 0.55 : 1, fontSize: "0.78rem", color: "#374151", fontWeight: 500 }}>
                              <FaImages style={{ color: "#058740" }} /> Gallery
                            </button>
                            <button type="button" onClick={() => setShowCamera("front")} disabled={uploadingCard === "front"} style={{ display: "flex", alignItems: "center", gap: "0.35rem", padding: "0.45rem 0.9rem", border: "1px solid #d1d5db", borderRadius: "0.5rem", background: "#fff", cursor: uploadingCard === "front" ? "not-allowed" : "pointer", opacity: uploadingCard === "front" ? 0.55 : 1, fontSize: "0.78rem", color: "#374151", fontWeight: 500 }}>
                              <FaCamera style={{ color: "#058740" }} /> Camera
                            </button>
                          </div>
                          <input ref={frontFileInputRef} type="file" name="frontCard" accept=".png,.jpg,.jpeg" onChange={(e) => handleGhanaCardUploadFront(e)} style={{ display: "none" }} />
                        </div>

                        {/* Back Card */}
                        <div style={{ background: "#fff", borderRadius: "0.75rem", border: "1px solid #e5e7eb", padding: "1rem", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.75rem" }}>
                            <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "#1f2937" }}>Ghana Card (Back)</span>
                            <CardStatus
                              uploading={uploadingCard === "back"}
                              uploaded={!!(previewPassportImage || temp_order?.passportImage)}
                            />
                          </div>
                          <div style={{ position: "relative", width: "100%", height: "160px", borderRadius: "0.5rem", border: "2px dashed #d1d5db", overflow: "hidden", display: "flex", alignItems: "center", justifyContent: "center", background: "#f9fafb", marginBottom: "0.75rem" }}>
                            {uploadingCard === "back" && <UploadOverlay />}
                            {(previewPassportImage || temp_order?.passportImage) ? (
                              <img src={previewPassportImage || temp_order?.passportImage} alt="Back ID" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            ) : (
                              <div style={{ textAlign: "center", color: "#9ca3af" }}>
                                <FaImages style={{ fontSize: "2rem", marginBottom: "0.3rem" }} />
                                <div style={{ fontSize: "0.75rem" }}>No image uploaded</div>
                              </div>
                            )}
                          </div>
                          <div style={{ display: "flex", gap: "0.5rem", justifyContent: "center" }}>
                            <button type="button" onClick={() => backFileInputRef.current.click()} disabled={uploadingCard === "back"} style={{ display: "flex", alignItems: "center", gap: "0.35rem", padding: "0.45rem 0.9rem", border: "1px solid #d1d5db", borderRadius: "0.5rem", background: "#fff", cursor: uploadingCard === "back" ? "not-allowed" : "pointer", opacity: uploadingCard === "back" ? 0.55 : 1, fontSize: "0.78rem", color: "#374151", fontWeight: 500 }}>
                              <FaImages style={{ color: "#058740" }} /> Gallery
                            </button>
                            <button type="button" onClick={() => setShowCamera("back")} disabled={uploadingCard === "back"} style={{ display: "flex", alignItems: "center", gap: "0.35rem", padding: "0.45rem 0.9rem", border: "1px solid #d1d5db", borderRadius: "0.5rem", background: "#fff", cursor: uploadingCard === "back" ? "not-allowed" : "pointer", opacity: uploadingCard === "back" ? 0.55 : 1, fontSize: "0.78rem", color: "#374151", fontWeight: 500 }}>
                              <FaCamera style={{ color: "#058740" }} /> Camera
                            </button>
                          </div>
                          <input ref={backFileInputRef} type="file" name="passport" accept=".png,.jpg,.jpeg" onChange={(e) => handleGhanaCardBackUpload(e)} style={{ display: "none" }} />
                        </div>
                      </div>

                      {/* Webcam Modal */}
                      {showCamera && (
                        <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.7)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}>
                          <div style={{ background: "#fff", borderRadius: "1rem", padding: "1.5rem", width: "90%", maxWidth: "420px", textAlign: "center", position: "relative" }}>
                            <button type="button" onClick={() => setShowCamera(null)} style={{ position: "absolute", top: "0.75rem", right: "0.75rem", background: "none", border: "none", cursor: "pointer", fontSize: "1.2rem", color: "#6b7280" }}>
                              <FaTimes />
                            </button>
                            <h4 style={{ marginBottom: "1rem", fontWeight: 600, color: "#1f2937" }}>
                              Take a Photo - {showCamera === "front" ? "Front" : "Back"}
                            </h4>
                            <div style={{ borderRadius: "0.75rem", overflow: "hidden", marginBottom: "1rem" }}>
                              <Webcam
                                ref={webcamRef}
                                audio={false}
                                screenshotFormat="image/png"
                                videoConstraints={{ facingMode: "environment", width: 400, height: 300 }}
                                style={{ width: "100%", borderRadius: "0.75rem" }}
                              />
                            </div>
                            <button type="button" onClick={capturePhoto} style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", padding: "0.65rem 2rem", background: "#058740", color: "#fff", border: "none", borderRadius: "0.5rem", cursor: "pointer", fontSize: "0.9rem", fontWeight: 500 }}>
                              <FaCamera /> Capture
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="flex justify-between items-center gap-3 mt-2">
                      <button
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none cursor-pointer"
                        name=""
                        onClick={() => setFormState(4)}
                        style={{ backgroundColor: "#e5e7eb", borderRadius: "1.5rem" }}
                      >
                        Back
                      </button>
                      <button
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none cursor-pointer"
                        name=""
                        onClick={(e) => {
                          e.preventDefault();
                          setFormState(6);
                        }}
                        style={{ backgroundColor: "#058740", borderRadius: "1.5rem" }}
                      >
                        Save and continue
                      </button>
                    </div>
                  </>
                )}
                {formState === 6 && (
                  <>
                    <h3 className="text-xl font-semibold mb-4 text-gray-800">Item Details </h3>

                    <div>
                      <div className="flex items-center justify-between gap-3 mb-4">
                        <h3 className="text-xl font-semibold text-gray-800">Product Info</h3>
                        <Link
                          to={"/upnmg-shopping-mall"}
                          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-green-700 bg-green-50 border border-green-200 rounded-full hover:bg-green-100 hover:border-green-300 focus:outline-none transition-colors"
                        >
                          <FaPlus size={11} /> Add another item
                        </Link>
                      </div>
                      {/* The table scrolls inside its own box at every width.
                          The old rule only did so under 500px, and the
                          Bootstrap table classes never applied — Bootstrap is
                          not a dependency of this project. */}
                      <div className="overflow-x-auto border border-gray-200 rounded-lg">
                        <table className="min-w-[620px] w-full text-sm text-left">
                          <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
                            <tr>
                              <th scope="col" className="px-4 py-3 font-semibold">#</th>
                              <th scope="col" className="px-4 py-3 font-semibold">Product name</th>
                              <th scope="col" className="px-4 py-3 font-semibold">Qty</th>
                              <th scope="col" className="px-4 py-3 font-semibold">Terms (m)</th>
                              <th scope="col" className="px-4 py-3 font-semibold">Instalment p/m</th>
                              <th scope="col" className="px-4 py-3 font-semibold"></th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-100">
                            {carts?.map((cart, index) => (
                              <tr key={index} className="text-gray-700">
                                <th scope="row" className="px-4 py-3 font-medium text-gray-500">
                                  {index + 1}
                                </th>
                                <td className="px-4 py-3">{cart?.product_id?.product_name}</td>
                                <td className="px-4 py-3">{cart?.quantity}</td>
                                <td className="px-4 py-3">{cart?.period}</td>
                                <td className="px-4 py-3">{cart?.period_price}</td>
                                <td className="px-4 py-3">
                                  <button
                                    type="button"
                                    title="Remove item"
                                    onClick={() => RemoveProductFromCart(cart?.product_id?._id)}
                                    className="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium text-red-600 bg-red-50 border border-red-200 rounded-md hover:bg-red-100 hover:border-red-300 focus:outline-none"
                                  >
                                    <Delete style={{ fontSize: "0.9rem" }} /> Delete
                                  </button>
                                </td>
                              </tr>
                            ))}
                            {carts?.length < 1 && (
                              <tr>
                                <td colSpan={6} className="px-4 py-6 text-center text-sm text-gray-500">
                                  No items in your cart. Add at least one item to continue.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="flex justify-between items-center gap-3 mt-2">
                      <div
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none cursor-pointer"
                        onClick={() => setFormState(5)}
                      >
                        Back
                      </div>
                      <button
                        type="button"
                        disabled={!(carts?.length > 0)}
                        style={!(carts?.length > 0) ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                        className="inline-flex items-center gap-2 justify-center px-6 py-2.5 bg-green-700 text-white font-medium text-sm rounded-lg hover:bg-green-800 focus:outline-none cursor-pointer"
                        onClick={(e) => {
                          e.preventDefault();
                          if (!(carts?.length > 0)) return;
                          setFormState(7);
                          window.scrollTo(0, 0);
                        }}
                      >
                        <FaEye size={13} /> Preview order
                      </button>
                    </div>
                  </>
                )}
                {formState === 7 && (
                  <>
                    <h3 className="text-xl font-semibold mb-1 text-gray-800">Preview Order</h3>
                    <p className="text-sm text-gray-600 mb-5">
                      Check everything below. Use Edit on any section to go back and correct it.
                    </p>

                    {/* Personal Information */}
                    <div className="bg-white border border-gray-200 p-4 sm:p-6 rounded-lg shadow-sm mb-4">
                      <SectionHeader title="Personal Information" step={1} />
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <ReadField label="Full Name" value={userData?.name} />
                        <ReadField label="Date of Birth" value={fmtDate(dateOfBirth || ov("dateOfBirth"))} />
                        <ReadField label="Age" value={(age || ov("age"))?.toString()} />
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <ReadField label="SSNIT" value={ov("ssnit")} />
                        <ReadField label="ID Type" value={ov("IdCardType") || "Ghana National Identification"} />
                        <ReadField label="ID Number" value={ov("IDCardNumber")} />
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <ReadField label="Gender" value={ov("gender")} />
                        <ReadField label="Residential Address (Line 1)" value={ov("residential_address1")} />
                        <ReadField label="Line 2" value={ov("residential_address2")} />
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <ReadField label="Work Address (Line 1)" value={ov("work_address1")} />
                        <ReadField label="Line 2" value={ov("work_address2")} />
                      </div>
                    </div>

                    {/* Contact Details */}
                    <div className="bg-white border border-gray-200 p-4 sm:p-6 rounded-lg shadow-sm mb-4">
                      <SectionHeader title="Contact Details" step={2} />
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <ReadField label="Phone Number" value={ov("personal_phone")} />
                        <ReadField label="Work Phone" value={ov("work_phone")} />
                        <ReadField label="Email Address" value={ov("email")} />
                      </div>
                      {!isStaff && (
                        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mt-4">
                          <ReadField label="Mandate Number 1" value={ov("mandate_number")} />
                          <ReadField label="OTP Number 1" value={ov("otp_number")?.toString()} />
                          <ReadField label="Mandate Number 2" value={ov("mandate_number2")} />
                          <ReadField label="OTP Number 2" value={ov("otp_number2")?.toString()} />
                        </div>
                      )}
                    </div>

                    {/* Guarantor 1 */}
                    <div className="bg-white border border-gray-200 p-4 sm:p-6 rounded-lg shadow-sm mb-4">
                      <SectionHeader title="Guarantor 1" step={3} />
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <ReadField label="Name" value={ov("guarantor_name")} />
                        <ReadField label="Staff ID" value={ov("guarantor_staff_id")} />
                        <ReadField label="Phone" value={ov("guarantor_phone")} />
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <ReadField label="Ghana Card" value={ov("guarantor_ghana_card")} />
                        <ReadField label="GPS Address" value={ov("guarantor_gps")} />
                        <ReadField label="Occupation" value={ov("guarantor_occupation")} />
                      </div>
                      <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-3"} gap-4`}>
                        {!isStaff && (
                          <>
                            <ReadField label="Mandate Number" value={ov("guarantor_mandate_number")} />
                            <ReadField label="OTP Number" value={ov("guarantor_otp_number")?.toString()} />
                          </>
                        )}
                        <ReadField label="Relationship" value={ov("guarantor_relationship")} />
                      </div>
                    </div>

                    {/* Guarantor 2 */}
                    <div className="bg-white border border-gray-200 p-4 sm:p-6 rounded-lg shadow-sm mb-4">
                      <SectionHeader title="Guarantor 2" step={3} />
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <ReadField label="Name" value={ov("guarantor_name2")} />
                        <ReadField label="Staff ID" value={ov("guarantor_staff_id2")} />
                        <ReadField label="Phone" value={ov("guarantor_phone2")} />
                      </div>
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <ReadField label="Ghana Card" value={ov("guarantor_ghana_card2")} />
                        <ReadField label="GPS Address" value={ov("guarantor_gps2")} />
                        <ReadField label="Occupation" value={ov("guarantor_occupation2")} />
                      </div>
                      <div className={`grid grid-cols-1 ${isStaff ? "" : "sm:grid-cols-3"} gap-4`}>
                        {!isStaff && (
                          <>
                            <ReadField label="Mandate Number" value={ov("guarantor_mandate_number2")} />
                            <ReadField label="OTP Number" value={ov("guarantor_otp_number2")?.toString()} />
                          </>
                        )}
                        <ReadField label="Relationship" value={ov("guarantor_relationship2")} />
                      </div>
                    </div>

                    {/* Employment Details */}
                    <div className="bg-white border border-gray-200 p-4 sm:p-6 rounded-lg shadow-sm mb-4">
                      <SectionHeader title="Employment Details" step={4} />
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4">
                        <ReadField label="Employer" value={ov("employer_name")} />
                        <ReadField label="Facility" value={userData?.facility} />
                        <ReadField label="Staff ID" value={userData?.staff_id} />
                      </div>
                      <div className={`grid grid-cols-1 ${isStaff ? "sm:grid-cols-2" : "sm:grid-cols-3"} gap-4`}>
                        <ReadField label="Employment Start Date" value={ov("employment_start_date")} />
                        {!isStaff && (
                          <ReadField label="Affordability (&#8373;)" value={ov("affordability")?.toString()} />
                        )}
                        <ReadField label="Occupation" value={ov("occupation")} />
                      </div>
                    </div>

                    {/* Uploaded Documents */}
                    <div className="bg-white border border-gray-200 p-4 sm:p-6 rounded-lg shadow-sm mb-4">
                      <SectionHeader title="Uploaded Documents" step={5} />
                      {(previewFrontCard || temp_order?.frontIDImage || previewPassportImage || temp_order?.passportImage) ? (
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                          {(previewFrontCard || temp_order?.frontIDImage) && (
                            <div className="border rounded-lg p-3">
                              <p className="text-sm font-medium text-gray-700 mb-2">Ghana Card (Front)</p>
                              <img src={previewFrontCard || temp_order?.frontIDImage} alt="front-id"
                                className="w-full h-44 object-contain rounded-md" />
                            </div>
                          )}
                          {(previewPassportImage || temp_order?.passportImage) && (
                            <div className="border rounded-lg p-3">
                              <p className="text-sm font-medium text-gray-700 mb-2">Ghana Card (Back)</p>
                              <img src={previewPassportImage || temp_order?.passportImage} alt="back-id"
                                className="w-full h-44 object-contain rounded-md" />
                            </div>
                          )}
                        </div>
                      ) : (
                        <p className="text-sm text-gray-500">
                          No documents uploaded yet. Use Edit to add your Ghana Card.
                        </p>
                      )}
                    </div>

                    {/* Items live in the cart, not the temporary order */}
                    <div className="bg-white border border-gray-200 p-4 sm:p-6 rounded-lg shadow-sm mb-4">
                      <SectionHeader title="Items" step={6} />
                      <div className="overflow-x-auto border border-gray-200 rounded-lg">
                        <table className="min-w-[560px] w-full text-sm text-left">
                          <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
                            <tr>
                              <th scope="col" className="px-4 py-3 font-semibold">#</th>
                              <th scope="col" className="px-4 py-3 font-semibold">Product name</th>
                              <th scope="col" className="px-4 py-3 font-semibold">Qty</th>
                              <th scope="col" className="px-4 py-3 font-semibold">Terms (m)</th>
                              <th scope="col" className="px-4 py-3 font-semibold">Instalment p/m</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-100">
                            {carts?.map((cart, index) => (
                              <tr key={index} className="text-gray-700">
                                <th scope="row" className="px-4 py-3 font-medium text-gray-500">{index + 1}</th>
                                <td className="px-4 py-3">{cart?.product_id?.product_name}</td>
                                <td className="px-4 py-3">{cart?.quantity}</td>
                                <td className="px-4 py-3">{cart?.period}</td>
                                <td className="px-4 py-3">{cart?.period_price}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="flex justify-between items-center mt-4 pt-3 border-t border-gray-200">
                        <span className="text-sm font-medium text-gray-700">Total per month</span>
                        <span className="text-lg font-semibold text-gray-900">
                          &#8373;{cartGrandTotal?.toFixed(2)}
                        </span>
                      </div>
                    </div>

                    <div className="acceptTerms">
                      <input
                        type="checkbox"
                        checked={termsChecked}
                        onChange={() => {
                          setTermsChecked(!termsChecked);
                        }}
                      />{" "}
                      <span className="terms">
                        I have read and agreed to all terms and conditions.{" "}
                        <Link to={"/mart_terms"} target="_blank">
                          Terms and conditions
                        </Link>
                      </span>
                    </div>

                    <div className="flex justify-between items-center gap-3 mt-2">
                      <div
                        className="inline-flex items-center justify-center px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none cursor-pointer"
                        onClick={() => setFormState(6)}
                      >
                        Back
                      </div>
                      <div></div>
                    </div>
                  </>
                )}

              </form>
            </div>
            <div className="mt-6 pt-4 border-t border-gray-200">
              <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
                <button
                  type="button"
                  onClick={() => setShowOrderForm(false)}
                  className="inline-flex items-center justify-center px-6 py-2.5 bg-white text-gray-700 font-medium text-sm rounded-lg border border-gray-400 hover:bg-gray-100 focus:outline-none cursor-pointer"
                >
                  Cancel
                </button>

                <button
                  type="button"
                  onClick={handleConfirmSubmit}
                  disabled={termsChecked === false || !(carts?.length > 0)}
                  title={
                    !(carts?.length > 0)
                      ? "Your cart is empty — add at least one item to continue"
                      : termsChecked
                      ? undefined
                      : "Accept the terms and conditions to continue"
                  }
                  className={`inline-flex items-center justify-center px-6 py-2.5 font-medium text-sm rounded-lg focus:outline-none transition-colors ${
                    termsChecked && carts?.length > 0
                      ? "bg-green-700 text-white hover:bg-green-800 cursor-pointer"
                      : "bg-gray-200 text-gray-500 border border-gray-300 cursor-not-allowed"
                  }`}
                >
                  Confirm Order
                </button>
              </div>
            </div>
            </div>
          </div>
        )}
      </RenderHome>
    </div>
  );
}

export default MyCart;
